import {SocialShare} from "../class-lib/social-share";

declare var ajaxDataMain: {
    home_url: string;
};

document.addEventListener('DOMContentLoaded', function () {
    new SocialShare();

    jQuery('.download-item').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        let form = document.getElementById('download-form') as HTMLFormElement;
        jQuery(form).find('input[name="hash"]').val(jQuery(this).data('hash'));
        jQuery(form).find('input[name="type"]').val(jQuery(this).data('type'));
        jQuery(form).find('input[name="files"]').val('');
        form.setAttribute("action", (ajaxDataMain?.home_url || window.location.origin) + "/dokument-herunterladen");
        window.open('', 'view');
        form.submit();
    })

    jQuery('.download-all').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        let form = document.getElementById('download-form') as HTMLFormElement;
        jQuery(form).find('input[name="files"]').val(jQuery(this).data('meta'));
        form.setAttribute("action", (ajaxDataMain?.home_url || window.location.origin) + "/dokument-herunterladen");
        window.open('', 'view');
        form.submit();
    })
});
